import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "px-3 py-1 container-fluid"
};
const _hoisted_2 = {
  class: "sidenav-toggler-inner"
};
const _hoisted_3 = {
  class: "navbar-nav justify-content-end"
};
const _hoisted_4 = {
  class: "nav-item d-xl-none ps-3 d-flex align-items-center"
};
const _hoisted_5 = {
  class: "sidenav-toggler-inner"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "dropdown-header noti-title"
}, [/*#__PURE__*/_createElementVNode("h6", {
  class: "text-overflow m-0"
}, "Welcome!")], -1);
const _hoisted_7 = {
  class: "mb-2"
};
const _hoisted_8 = {
  class: "dropdown-item border-radius-md",
  href: "javascript:;"
};
const _hoisted_9 = {
  class: "py-1 d-flex"
};
const _hoisted_10 = {
  class: "d-flex flex-column justify-content-center"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "ni ni-single-02"
}, null, -1);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "font-weight-bold"
}, "Update Password", -1);
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = {
  class: "mb-2"
};
const _hoisted_15 = {
  class: "dropdown-item border-radius-md",
  href: "javascript:;"
};
const _hoisted_16 = {
  class: "py-1 d-flex"
};
const _hoisted_17 = {
  class: "d-flex flex-column justify-content-center"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", {
  class: "ni ni-user-run"
}, null, -1);
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "font-weight-bold"
}, "Logout", -1);
const _hoisted_20 = [_hoisted_18, _hoisted_19];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_breadcrumbs = _resolveComponent("breadcrumbs");
  return _openBlock(), _createElementBlock("nav", _mergeProps({
    id: "navbarBlur",
    class: `${!_ctx.isNavFixed ? 'navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none' : `navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none position-sticky ${_ctx.darkMode ? 'bg-default' : 'bg-white'} left-auto top-2 z-index-sticky`} ${_ctx.isRTL ? 'top-0 position-sticky z-index-sticky' : ''}`
  }, _ctx.$attrs, {
    "data-scroll": "true"
  }), [_createElementVNode("div", _hoisted_1, [_createVNode(_component_breadcrumbs, {
    "current-page": $options.currentRouteName,
    "current-directory": $options.currentDirectory
  }, null, 8, ["current-page", "current-directory"]), _createElementVNode("div", {
    class: _normalizeClass(["sidenav-toggler sidenav-toggler-inner d-xl-block d-none", _ctx.isRTL ? 'me-3' : ''])
  }, [_createElementVNode("a", {
    href: "#",
    class: "p-0 nav-link text-body",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => _ctx.navbarMinimize && _ctx.navbarMinimize(...args), ["prevent"]))
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("i", {
    class: _normalizeClass(["sidenav-toggler-line", _ctx.isNavFixed && !_ctx.darkMode ? ' opacity-8 bg-dark' : 'bg-white'])
  }, null, 2), _createElementVNode("i", {
    class: _normalizeClass(["sidenav-toggler-line", _ctx.isNavFixed && !_ctx.darkMode ? ' opacity-8 bg-dark' : 'bg-white'])
  }, null, 2), _createElementVNode("i", {
    class: _normalizeClass(["sidenav-toggler-line", _ctx.isNavFixed && !_ctx.darkMode ? ' opacity-8 bg-dark' : 'bg-white'])
  }, null, 2)])])], 2), _createElementVNode("div", {
    id: "navbar",
    class: _normalizeClass(["mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4", _ctx.isRTL ? 'px-0' : 'me-sm-4'])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["pe-md-3 d-flex align-items-center", _ctx.isRTL ? 'me-md-auto' : 'ms-md-auto'])
  }, null, 2), _createElementVNode("ul", _hoisted_3, [_createElementVNode("li", _hoisted_4, [_createElementVNode("a", {
    id: "iconNavbarSidenav",
    href: "#",
    class: "p-0 nav-link text-white",
    onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => _ctx.navbarMinimize && _ctx.navbarMinimize(...args), ["prevent"]))
  }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("i", {
    class: _normalizeClass(`sidenav-toggler-line ${_ctx.isNavFixed && !_ctx.darkMode ? ' opacity-8 bg-dark' : 'bg-white'}`)
  }, null, 2), _createElementVNode("i", {
    class: _normalizeClass(`sidenav-toggler-line ${_ctx.isNavFixed && !_ctx.darkMode ? ' opacity-8 bg-dark' : 'bg-white'}`)
  }, null, 2), _createElementVNode("i", {
    class: _normalizeClass(`sidenav-toggler-line ${_ctx.isNavFixed && !_ctx.darkMode ? ' opacity-8 bg-dark' : 'bg-white'}`)
  }, null, 2)])])]), _createElementVNode("li", {
    class: _normalizeClass(["nav-item dropdown d-flex align-items-center", _ctx.isRTL ? 'ps-' + '2' : 'pe-2'])
  }, [_createElementVNode("button", {
    class: "pr-10 nav-link text-white",
    onClick: _cache[2] || (_cache[2] = $event => $options.fnChangeLocale($options.LOCALE_CODE.ko)),
    style: {
      "background-color": "#a92222",
      "margin-right": "1rem"
    }
  }, " Korea "), _createElementVNode("button", {
    class: "pr-10 nav-link text-white",
    onClick: _cache[3] || (_cache[3] = $event => $options.fnChangeLocale($options.LOCALE_CODE.en)),
    style: {
      "background-color": "#0066cc",
      "margin-right": "1rem"
    }
  }, " English "), _createElementVNode("button", {
    class: "pr-10 nav-link text-white",
    onClick: _cache[4] || (_cache[4] = $event => $options.fnChangeLocale($options.LOCALE_CODE.vn)),
    style: {
      "background-color": "#17ad37",
      "margin-right": "1rem"
    }
  }, " Vietnam "), _createElementVNode("a", {
    id: "dropdownMenuButton",
    href: "#",
    class: _normalizeClass(`p-0 nav-link ${_ctx.isNavFixed && !_ctx.darkMode ? ' opacity-8 text-dark' : 'text-white'} ${$data.showMenu ? 'show' : ''}`),
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false",
    onClick: _cache[5] || (_cache[5] = $event => $data.showMenu = !$data.showMenu)
  }, " Hello, " + _toDisplayString(_ctx.loginData.name), 3), _createElementVNode("ul", {
    class: _normalizeClass(["px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4", $data.showMenu ? 'show' : '']),
    "aria-labelledby": "dropdownMenuButton"
  }, [_hoisted_6, _createElementVNode("li", _hoisted_7, [_createElementVNode("a", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("h6", {
    class: "mb-1 text-sm font-weight-normal",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.changePassword && $options.changePassword(...args))
  }, _hoisted_13)])])])]), _createElementVNode("li", _hoisted_14, [_createElementVNode("a", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("h6", {
    class: "mb-1 text-sm font-weight-normal",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.logout && $options.logout(...args))
  }, _hoisted_20)])])])])], 2)], 2)])], 2)])], 16);
}